import React, { useState, useRef, useId } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface ToolTipTitleBodyProps {
  content: React.ReactNode;
  children: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  delay?: number;
  stickyClick?: boolean;
  ispositionCenter?: boolean;
}

interface ToolTipTitleBodyIconProps {
  icon: IconDefinition;
  titleMessage: string;
  bodyMessage: string;
  position?: "top" | "right" | "bottom" | "left";
  stickyClick?: boolean;
  delay?: number;
  direction?: string;
  iconPositionCenter?: boolean;
}

const ToolTipTitleBody: React.FC<ToolTipTitleBodyProps> = ({
  content,
  delay = 100,
  children,
  position = "bottom",
  stickyClick = false,
  ispositionCenter = false,
}) => {
  const tooltipId = useId();
  const [isActive, setActive] = useState(false);
  const [clickedin, setClickedin] = useState(false);
  const timeout = useRef<number>(0);

  function showTip() {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      setActive(true);
    }, delay);
  }

  function hideTip() {
    clearTimeout(timeout.current);
    if (!clickedin) {
      setActive(false);
    }
  }

  function toggle() {
    setActive(!clickedin);
    setClickedin(!clickedin);
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (e.key === "Escape") {
      setActive(false);
      setClickedin(false);
      return;
    }

    if (!stickyClick) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  }

  return (
    <div
      className={`tooltip-wrapper${isActive ? " tooltip-open" : ""}${ispositionCenter ? " tooltip-content-center" : ""}`}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      onFocus={showTip}
      onBlur={hideTip}
      onKeyDown={handleKeyDown}
      onClick={stickyClick ? toggle : () => {}}
      tabIndex={stickyClick ? 0 : undefined}
      aria-describedby={isActive ? tooltipId : undefined}
    >
      {children}
      {isActive && (
        <div id={tooltipId} role="tooltip" className={`tooltip-tip ${position}`}>
          {content}
        </div>
      )}
    </div>
  );
};

const ToolTipTitleBodyIcon: React.FC<ToolTipTitleBodyIconProps> = ({
  icon,
  titleMessage,
  bodyMessage,
  position = "bottom",
  stickyClick,
  delay,
  iconPositionCenter = false,
}) => {
  return (
    <ToolTipTitleBody
      ispositionCenter={iconPositionCenter}
      content={
        <>
          <div className="title-class">{titleMessage}</div>
          <div className="body-class">{bodyMessage}</div>
        </>
      }
      position={position}
      stickyClick={stickyClick}
      delay={delay}
    >
      <FontAwesomeIcon icon={icon} />
    </ToolTipTitleBody>
  );
};

export default ToolTipTitleBodyIcon;
